<template>
    <a class="iconbutton" role="button" tabindex="0" aria-label="Edit" :aria-disabled="disabled"
       @click="$emit('click')" @keydown.enter.prevent="$emit('click')" @keydown.space.prevent="$emit('click')">
        <img alt="" aria-hidden="true" src="@/assets/pencil.png"  class="iconimage" >
    </a>
</template>

<script>
export default {
    name:'pencilbutton',
    props:{
        
        disabled:{
          type:Boolean,
          default:false
        }
    },
    data() {
        return {
            
        };
    },
}
</script>

<style >

.iconbutton:hover{
    
    cursor:pointer;
}

.iconimage{
    width:11px;
}
</style>